<template>
    <div class="grey lighten-3 px-4 pb-4 pt-2 greyContainer">
        <div v-if="user.permissions.pass && massDelete">
            <v-card-title class="pb-0">
                <v-icon class="mr-1">mdi-account-remove</v-icon>Spieler löschen
                <v-spacer/>
                <v-btn color="primary" @click="massDelete.loadInaktiveSpieler()">Löschliste laden</v-btn>
            </v-card-title>
            <mass-delete-list v-if="massDelete.deleteableSpieler.length>0" :mass-delete="massDelete"/>
        </div>
        <v-alert v-else text color="error" icon="mdi-information">
            Du hast leider keine Berechtigung für diesen Bereich!
        </v-alert>
    </div>
</template>

<script>
import {MassDeleteService} from "@/services/data/massDelete/massDelete";
import MassDeleteList from "@/views/massDelete/massDeleteList";

export default {
    name: "massDelete",
    components: {MassDeleteList},
    computed: {
        user(){ return this.$store.state.user }
    },
    data: () => ({
        massDelete: null,
    }),
    created(){
        this.init()
    },
    methods: {
        init(){
            this.massDelete = new MassDeleteService()
        }
    },
}
</script>

<style scoped>
    .greyContainer{position: fixed; top: 48px; bottom: 0; left: 0; right: 0; overflow-y: scroll}
</style>